export const encodeConfig = <T>(value: T): string => btoa(JSON.stringify(value))
export const decodeConfig = <T>(value: string): T => JSON.parse(atob(value))
